module.exports = __webpack_public_path__ + "images/51743ae32a979174bd3ca5f0f95f6691ca4637acef6194399cbfa3668de12771.svg";